import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Moment from "moment";
import { Link } from "react-router-dom";
import _ from "lodash";

@inject("UserStore", "AdminStore")
@observer
class History extends Component {
  componentDidMount() {
    if (this.props.admin) {
      this.props.AdminStore.getUserOrders(
        this.props.AdminStore.userProfile._id
      );
    } else {
      this.props.UserStore.getMyOrders();
    }
  }

  getOrderRange = products => {
    const startDate = products.reduce((startDate, product) => {
      const prevDate = Moment(startDate);
      const currentDate = Moment(product.startsAt);
      return currentDate.isBefore(prevDate) ? product.startsAt : prevDate;
    }, Date.now());
    const endDate = products.reduce((endDate, product) => {
      const prevDate = Moment(endDate);
      const currentDate = Moment(product.endsAt);
      return currentDate.isAfter(prevDate) ? product.endsAt : prevDate;
    }, Date.now());

    return {
      startDate: Moment(startDate).format("MMM DD, YYYY"),
      endDate: Moment(endDate).format("MMM DD, YYYY")
    };
  };

  render() {
    const { UserStore, AdminStore, admin } = this.props;
    const orders = admin ? AdminStore.userOrders : UserStore.orders;
    return (
      <div className="history">
        <div className="head-entry entry">
          <p>Date Placed</p>
          <p>Price</p>
          <p>Rented for</p>
          <p>Rented from</p>
          <p>Rented to</p>
          <p>Order Status</p>
          <p>Picked/Shipped</p>
          <p />
        </div>
        {orders.map(order => {
          const { startDate, endDate } = this.getOrderRange(order.products);
          return (
            <div className="entry">
              <p>{Moment(order.created_at).format("MMM DD, YYYY")}</p>
              <p>${order.value.toFixed(2)}</p>
              <p
                style={{
                  textTransform: "capitalize"
                }}
              >
                {Moment.duration(
                  Moment(startDate).diff(endDate, "days"),
                  "days"
                ).humanize()}
              </p>
              <p>{startDate}</p>
              <p>{endDate}</p>
              <p>{_.startCase(order.status)}</p>
              <p>{order.pickedUp ? "Picked Up" : "Shipped"}</p>
              <p>
                <Link
                  to={`${admin ? "/admin" : ""}/orders/${order._id}`}
                  className="order-btn"
                >
                  View Order
                </Link>
              </p>
            </div>
          );
        })}
      </div>
    );
  }
}

export default History;



// WEBPACK FOOTER //
// ./src/components/History.js